import enMessages from '../locales/ja_JP';

const JaLang = {
  messages: {
    ...enMessages,
  },
  locale: 'ja-JP',
};
export default JaLang;
